import styled from "styled-components";
import { windowWidth } from "@styles/global";
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";

interface StylesheetProps {
  platform: ScreenPlatform;
}

export const Container = styled.div<StylesheetProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  margin-top: ${(prop) => (prop.platform === "mobile" ? "5rem" : "0")};
`;

export const ContainerModalDetails = styled.div`
  z-index: 2001;

  .MuiDialog-paper {
    width: 1200px;

    .mContent {
      padding-left: 32px;

      .MuiTypography-root {
        width: 100%;
      }
      .MuiFormControl-root {
        width: 100%;

        .MuiFormHelperText-root {
          text-align: right;
          margin: 0;
        }
      }
    }
    .mFooter {
      justify-content: flex-end;
    }
  }
`;

export const ContainerModalNewRegister = styled.div`
  z-index: 2001;

  .MuiDialog-paper {
    width: 1200px;

    .mContent {
      padding-left: 32px;

      .MuiTypography-root {
        width: 100%;
      }
      .MuiFormControl-root {
        width: 100%;

        .MuiFormHelperText-root {
          text-align: right;
          margin: 0;
        }
      }
    }
    .mFooter {
      justify-content: space-between;
    }
  }
`;
